"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * Popup-Widget baut auf dem Bootstrap Popover auf.
 *
 * @class
 * @extends gc.gis.widget.GCWidget
 * @memberof gc.gis.widget
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen.
 * @param {string} options.title Überschrift.
 * @param {jQuery} options.content Inhaltselement.
 * @param {jQuery} [options.container={@link gc.gis.iface.ui.main}] Element, an dem sich das Popup ausrichten soll.
 * @param {int} [options.x] Abstand zum linken Rand.
 * @param {int} [options.y] Abstand von oben.
 * @param {boolean} [options.draggable=true] Flag, ob das Popup verschoben werden darf.
 * @param {function} [options.close] Callback beim Schließen.
 */
gc.gis.widget.GCPopup = function( options )
{
    gc.gis.widget.GCWidget.call(this, options);

    this.title = options.title || 'Popover';
    this.content = options.content;

    this.container = options.container || gc.gis.iface.ui.main;
    this.x = options.x;
    this.y = options.y;
    this.draggable = options.draggable || true;
    this.destroyOnClose = true;
    this.close_callback = options.close;

    this.isVisible = false;
    this.isMinimized = false;   // TODO implementieren
};
gc.gis.widget.GCPopup.prototype = Object.create( gc.gis.widget.GCWidget.prototype );

/**
 * Zeigt den Popover an.
 *
 * @public
 * @method
 */
gc.gis.widget.GCPopup.prototype.show = function()
{
    if (!this.element) {
        this.container.append(this.getElement());   // getElement calls _render()
    }
    // this.getElement().popover({});   // div. options
    this._updatePosition();
    this.getElement().popover('show');

    this.isVisible = true;
    this.isMinimized = false;
};

/**
 * Schließt den Popover, das Element bleibt im Parent erhalten.
 *
 * @public
 * @method
 */
gc.gis.widget.GCPopup.prototype.close = function()
{
    if (this.isVisible)
    {
        var pos = this.getElement().position();
        this.x = pos.left;
        this.y = pos.top;
        this.isVisible = false;

        this.getElement().toggle(false);
    }

    if (this.destroyOnClose)
    {
        this.destroy();
    }
};

/**
 * Schließt und entfernt den Popover aus seinem Parent.
 *
 * @public
 * @method
 */
gc.gis.widget.GCPopup.prototype.destroy = function()
{
    if (this.element)
    {
        this.element.remove();
        this.element = null;
    }
};

/**
 * @inheritdoc
 */
gc.gis.widget.GCPopup.prototype._render = function()
{
    var self = this;

    // Hauptelement
    this.element = jQuery('<div>', {
        class: 'gc-widget-popup popover'
                + (this.className ? ' ' + this.className : '')
    });

    // Titelleiste
    var title_content = '<span>' + this.title + '</span>'
        + '<div class="gc-buttons">'
        +   '<button type="button" class="close" aria-label="Schließen"><span aria-hidden="true">&times;</span></button>'
        + '</div>';

    var title_element = jQuery('<div>', {
        class: 'popover-title',
        html: title_content
    });

    title_element.find('.close').click(function (evt) {
        if(typeof self.close_callback === 'function') {
            self.close_callback(self, evt);
        }
        else {
            self.close();
        }
    });

    this.element.append(title_element);

    // Inhaltsbereich
    this.element.append( jQuery('<div>', {
        class: 'popover-content',
        html: this.content
    }) );


    if (this.draggable)
    {
        this.element.draggable({
            handle: '.popover-title'
        });
        title_element.addClass('gc-draggable-area');
    }

    return this.element;
};

gc.gis.widget.GCPopup.prototype._updatePosition = function(position)
{
    // TODO: Sonderbehandlung für mobile Geräte
    // ggf. Standardposition ermittln
    this.x = this.x || this.container.width() / 2 - this.element.width() / 2;
    this.y = this.y || 50;

    position = position || {};
    position.x = position.x || this.x;
    position.y = position.y || this.y;

    this.getElement().css({
        left: position.x,
        top: position.y,
        transform: 'translate3d(0, 0, 0)'
    });
};